module.exports = __webpack_public_path__ + "06fb61e13f5f31b927a8d2ddc104c84a.pdf";